import { BaodianRule } from './types';

export const JOY_TENNIS_BAODIAN: BaodianRule[] = [
  // --- SINGLES MASTERY (单打18条黄金胜率法则) ---
  {
    id: 's01',
    category: 'singles',
    title: '沃德洛第一定律：斜线相持不过线',
    titleEn: 'Wardlaw Rule #1: Hold Crosscourt Baseline',
    formula: '斜线对角距离长，网心三尺不张扬；深区压制后场角，绝不轻易变直线。',
    summary: '相持阶段优先击打斜线。斜线球网最低(3英尺)，场馆对角线比直线长4.5英尺，安全容错空间高出40%。',
    details: [
      '在红区（底线后）与黄区（底线附近），80%以上的来球应顺向回击大斜线。',
      '直线穿过球网两端最高处(3.5英尺)，距离短且容易出界或挂网。',
      '斜线能有效将对手拉出单打边线，为随后的下分创造出几何空档。'
    ],
    drills: [
      '对角线深区连续抽球50拍不失误拉练',
      '在发球线与底线之间放置标志桶，击球落点必须在标志桶后方'
    ],
    tags: ['沃德洛法则', '斜线', '相持安全']
  },
  {
    id: 's02',
    category: 'singles',
    title: '沃德洛第二定律：迎前入场方变线',
    titleEn: 'Wardlaw Rule #2: Step Inside Before Down-the-Line',
    formula: '球出浅区脚迎前，击球点在身子前；重心前压抽直线，穿刺空档一剑咽。',
    summary: '只有在踏入场内（绿区）且击球点处于腰部舒适区时，方可发力变直线制胜。',
    details: [
      '改变球路（将斜线变为直线）需要克服球的自转与离心力，失误风险急剧上升。',
      '绝不在退后防守时打被动直线，那通常是给对手送出斜线大角度穿越的机会。',
      '打直线瞄准边线内侧1米安全走廊，切忌压死边线。'
    ],
    drills: [
      '浅球反弹迎前正手抽直线空档击杀训练',
      '两点移动：斜线相持2拍 -> 抓浅球上步直线制胜分'
    ],
    tags: ['进攻变线', '直线制胜', '迎前击球']
  },
  {
    id: 's03',
    category: 'singles',
    title: '压深打浅：深度压制胜过暴力球速',
    titleEn: 'Depth Over Pace: Deep Squeezes Short',
    formula: '莫贪极速盲目抽，深落底线对手愁；球不过网万事空，回球深区自占优。',
    summary: '网球业余与竞技分水岭是“回球深度”。回球落在发球线内的浅球会被无情惩戒，落在底线1米内的深球能封锁对手全部进攻。',
    details: [
      '球过网高度保持在网带上方3到4英尺（约1米），利用强烈的上旋让球深下坠。',
      '不需要打出时速120公里的平击，时速80公里且深压底线的重上旋更具威慑力。',
      '深球会压缩对手击球空间，迫使对手后退或在肩膀以上极不舒服的高度击球。'
    ],
    drills: [
      '深球打靶：在底线内1.5米划出得分带，只有落入该区域才计分',
      '高弧度上旋过网练习：在球网正上方架设一根绳子（高出球网1米），所有击球必须越过绳子'
    ],
    tags: ['击球深度', '过网高度', '重上旋']
  },
  {
    id: 's03_spin',
    category: 'singles',
    title: '旋转物理学：马格努斯效应与极限控球',
    titleEn: 'Spin Aerodynamics: Magnus Effect & Trajectory Control',
    formula: '平击如赌命悬丝，上旋急坠天地宽；下旋贴地滑三尺，旋转在心球不翻。',
    summary: '现代网球的核心武器不是单纯的球速，而是转速(RPM)。重上旋利用气压差制造向下的马格努斯下压力，即使过网1米高仍能急剧俯冲落在界内；切削下旋则产生悬浮升力并落地贴地滑窜。',
    details: [
      '【上旋向下俯冲】纳达尔与阿尔卡拉斯拥有 3200+ RPM 的上旋转速，球在飞行中受到强大的向下垂直分力，落地后产生 1.6m 以上的高弹跳压迫对手反手肩部。',
      '【切削悬浮贴地】费德勒式反手切削具备 2500 RPM 的后旋，抵消部分重力形成空中滑翔，触地后摩擦力反弹高度仅 0.35m，迫使对手弯腰从脚下捞球。',
      '【平击风险边界】纯平击转速低（<1200 RPM），过网高度容错窗口仅 0.5-1 英尺，只在踏入进攻绿区的半场制胜分时采用，底线相持切忌盲目平抽。'
    ],
    drills: [
      '高转速刷球打靶：手抛球专注由下往上刷出每秒50转急坠弧线',
      '切削低平滑行穿网带上方15公分深压底线训练'
    ],
    tags: ['马格努斯效应', '上旋转速', 'RPM', '切削贴地']
  },
  {
    id: 's04',
    category: 'singles',
    title: '侧身攻反手：主宰全场的 Inside-Out 杀招',
    titleEn: 'Inside-Out Forehand Dominance',
    formula: '反手位前小碎步，侧身让位正手舞；借力反抽对手反，拉开空门势如虎。',
    summary: '用最强的武器打击对手最弱的翅膀。侧身正手攻对手反手位是职业与高手的核心统治战术。',
    details: [
      '看到来球落在中路或反手位浅球，脚下快速呈弧线向左后方移动让出击球空间。',
      '身体呈开放式或半开放式站姿，拍头从下往外上方有力随挥。',
      '一旦对手被压在反手深角回出勉强软球，立刻反手位打 Inside-In (变直线) 锁定胜局。'
    ],
    drills: [
      '后场反手位侧身正手连续靶向训练',
      '组合球：侧身 Inside-Out 斜线拉开 -> 随后抓空档 Inside-In 直线'
    ],
    tags: ['侧身正手', 'Inside-Out', '进攻套路']
  },
  {
    id: 's05',
    category: 'singles',
    title: '发球加一分：Serve + 1 黄金抢攻战术',
    titleEn: 'The Serve + 1 Formula',
    formula: '一发落点早设计，落地反弹抓回击；正手迎前半场拍，两拍之内定乾坤。',
    summary: '现代网球70%的得分发生在4拍以内。发球不是孤立的技术，而是第一进攻回合的先导炮。',
    details: [
      '发球前脑海预判对手接发回球路线（通常是中路或较软的斜线）。',
      '发球落地随重心落入场内，迅速准备强力正手进攻（Serve + 1）。',
      '第一分球（+1）打向与发球落点相反的空档，或者追身打对手重心移动的后方。'
    ],
    drills: [
      '发外角一发 + 快速回位 + 强力正手攻对方另一侧底线角',
      '发内角中路 T 点 + 上步中场正手抽杀两边'
    ],
    tags: ['发球抢攻', 'Serve+1', '4拍得分']
  },
  {
    id: 's06',
    category: 'singles',
    title: '克制月亮球与磨工：上步截杀与节奏突变',
    titleEn: 'Neutralizing Moonballers & Pushers',
    formula: '莫跟磨工拼高球，踏入场内空中收；凌空抽截断退路，小球放短破龟谋。',
    summary: '打磨工月亮球（Pusher/Moonball）切忌心浮气躁盲目发力。通过改变击球节奏、凌空抽球与短球调动瓦解其防线。',
    details: [
      '在底线后等月亮球落下会非常费力，应勇敢踏入场内打“上升期”，在最高点击打。',
      '使用“凌空抽击 (Drive Volley)”在球落地前直接中场拦截，剥夺对手回位时间。',
      '使用下旋轻切短球，吸引防守者离开舒适的底线深处，再反手挑过顶或反角穿越。'
    ],
    drills: [
      '中场深高球上升点迎前截击拉练',
      '长抽结合突然隐蔽放短球专项对抗'
    ],
    tags: ['克制磨工', '月亮球', '凌空抽击']
  },

  // --- DOUBLES STRATEGY (双打绝胜战术宝典) ---
  {
    id: 'd01',
    category: 'doubles',
    title: '双打第一天条：打网前打脚下，打底线打中间',
    titleEn: 'Hit at Feet of Net, Hit Down the Middle of Baseline',
    formula: '网前对决压双足，底线深球打中路；脚下挑球必起高，中路相争互推橹。',
    summary: '双打的球路几何与单打截然不同。逼迫网前选手弯腰捞球，在底线利用中路引发搭档让球误解。',
    details: [
      '当对方一人在网前一人在底线时，击球千万不要给网前选手腰部以上的高球。',
      '强烈上旋或低平切削直钻网前选手两脚之间，他们只能勉强起球，你的网前搭档即可高压下分。',
      '底线中路打在两人之间，消除了回球角度，并极易引起搭档间的“你接还是我接”迟疑。'
    ],
    drills: [
      '底线给网前球员脚下喂低球防守截击 drill',
      '双打实战底线双人中路防守球权分配默契演练'
    ],
    tags: ['双打铁律', '打脚下', '中路球']
  },
  {
    id: 'd02',
    category: 'doubles',
    title: '网前雨刷器法则与包夹封网 (Pinch & Cover)',
    titleEn: 'Windshield Wiper & Net Pinching',
    formula: '球去左边移向左，球往右侧随球过；斜向压网封角度，截击下分如摘朵。',
    summary: '网前选手不是看客，移动如同雨刷器随球晃动。搭档击球向哪边，网前就向同侧压进半步封死直线。',
    details: [
      '搭档回球到对方正手斜线，网前选手向左斜前方移动两步（Pinch），封堵对方的直接回击角。',
      '绝不呆立在发球区正中，网前选手站位离网约2-2.5米，视线盯住对方接球手的引拍拍面。',
      '只要对方接球手抬头看球不看你，立即启动向中路抢网（Poach）截击！'
    ],
    drills: [
      '二人网前联动雨刷器横向折返封网训练',
      '搭档底线击球瞬间，网前根据来球弧线快速前压截击打靶'
    ],
    tags: ['雨刷器移动', '包夹封网', '抢网']
  },
  {
    id: 'd03',
    category: 'doubles',
    title: 'I阵型与澳式站位破局大法',
    titleEn: 'I-Formation & Australian Formation Playbook',
    formula: '发球蹲踞中线立，暗号手势指西东；封死斜线破常套，打乱接发阵脚空。',
    summary: '打破常规站位，在关键局（如抢七、破发点）使用I阵型或澳式站位，彻底瘫痪对手习惯的斜线接发。',
    details: [
      '网前搭档蹲在发球线与中线交界处，背后向发球员比手势（拳头=原地，开掌=抢网，食指=左，小指=右）。',
      '迫使接发球选手在没有角度参考的情况下只能冒险变直线或挑高球，失误率倍增。',
      '澳式站位将两人置于球场同侧，直接将发球方最强的网前截击者挡在接发球选手习惯的斜线路上。'
    ],
    drills: [
      'I阵型手势暗号配合实战发球抢网专项练习',
      '接发球面对澳式站位的破局直线穿越与挑高球演练'
    ],
    tags: ['I阵型', '澳式站位', '战术变阵']
  },
  {
    id: 'd04',
    category: 'doubles',
    title: '双上网压迫：现代高阶双打的制胜形态',
    titleEn: 'Both-at-Net Aggressive Domination',
    formula: '一前一后多被动，双双压网势如虹；压缩空间夺主动，中前场拦截百发中。',
    summary: '统计显示，双上网的一方赢得双打回合的概率高达68%。一前一后容易被对方各个击破。',
    details: [
      '底线搭档一旦打出深球或迫使对方起高球，必须果断随球上网，与搭档形成并排截击铜墙铁壁。',
      '双上网站位注意两人间隔保持3米左右，平行移动，防范对方从两人中间偷袭。',
      '一旦被挑过顶高球，斜后方跑位的搭档大喊“我的！”，另一人迅速换位补防斜对角底线。'
    ],
    drills: [
      '随球上网（Chip & Charge / Approach Shot）衔接截击训练',
      '被挑高球后的搭档交叉换位底线救球重置练习'
    ],
    tags: ['双上网', '截击压迫', '换位补防']
  },

  // --- SERVE & RETURN (发球与接发球心法) ---
  {
    id: 'r01',
    category: 'serve_return',
    title: '二发安全至上：上旋二发弹踢压反手',
    titleEn: '2nd Serve Kick to Backhand Safety',
    formula: '二发绝非软绵绵，刷出强旋向上窜；高弹跳向反手肩，不过双误保江山。',
    summary: '业余选手输球50%源于软弱二发被直接轰杀或双误送分。练就一记带强烈侧上旋的Kick发球是立足之本。',
    details: [
      '抛球位置略偏头顶后方（11点钟至12点钟方向），拍头由左下向右上快速刷过球的后侧。',
      '挥拍速度不减反增！利用挥拍速度制造每秒40转以上的剧烈上旋，让球越过球网1米仍能急速下坠入界。',
      '目标落点专打对方反手位深角，球落地后弹跳高度过肩，让对手无法借力借势抽杀。'
    ],
    drills: [
      '在发球区分格放置目标纸箱，连续50个二发踢向反手位外角',
      '跪地发球或手腕放松甩鞭发球动作感知练习'
    ],
    tags: ['二发', 'Kick发球', '压反手']
  },
  {
    id: 'r02',
    category: 'serve_return',
    title: '接二发上步截击：撕咬二发建立心理威慑',
    titleEn: 'Step In & Attack the 2nd Serve',
    formula: '见其抛球偏软弱，垫步入场站线前；半场正手深撕角，接发即抢主动权。',
    summary: '不要退在底线等慢速二发落下来打。向前跨进底线1-2米，在上升期迎前截打，彻底摧毁发球方的心理安全感。',
    details: [
      '分腿垫步（Split Step）的时机必须在对方击球瞬间落地蓄力。',
      '引拍幅度减半！二发进攻依靠身体向前冲的重心借力，短小紧凑的引拍能保证击球干净纯粹。',
      '回球目标：直抽对方发球后正在回位或上网的脚下，或者深撕斜线大角。'
    ],
    drills: [
      '底线内1米站位快速抢攻二发回击深角靶位',
      '搭档在发球线手抛模拟慢二发，连续迎前抽击练习'
    ],
    tags: ['接发球抢攻', '分腿垫步', '心理威慑']
  },

  // --- MENTAL & INNER GAME (心理韧性与内省心法) ---
  {
    id: 'm01',
    category: 'mental',
    title: '内省球心：静止评判的 Self 1 与 Self 2',
    titleEn: 'The Inner Game: Silencing Self 1',
    formula: '失误莫要骂自己，肌肉记忆凭神会；专注呼吸盯接缝，放下执念球自飞。',
    summary: '源自网球心理圣经《The Inner Game of Tennis》。打球的是身体与潜意识(Self 2)，不要让大脑的评判(Self 1)指手画脚。',
    details: [
      '击球失误后，禁止自怨自艾或喋喋不休（如“怎么搞的又打飞了”），这会强化身体肌肉的紧张。',
      '把注意力从“我必须赢/我不能输”转移到中性观察上：看清来球的黄色缝线与旋转方向。',
      '相信潜意识与身体的无数次训练肌肉记忆，给予身体完全的挥拍信任。'
    ],
    drills: [
      '“Bounce-Hit (弹起-击打)”发声呼吸冥想法：球落地心里念Bounce，触球念Hit',
      '30秒静心呼吸法：分与分之间抚摸拍线，调整心率归零'
    ],
    tags: ['内省心法', '专注', '心理韧性']
  },
  {
    id: 'm02',
    category: 'mental',
    title: '关键分心理学：30-30 与破发点的胜负手',
    titleEn: 'Clutch Points Mastery: 30-30 & Break Points',
    formula: '平分落后莫慌张，回归高胜率套路；发球加力求一发，绝不赌徒拼盲目。',
    summary: '网球比分不是平均分布的。30-30、40-30、30-40 和抢七前三分是决定整场走势的神经中枢。',
    details: [
      '在破发点或关键分上，绝不尝试平时训练命中率低于80%的非常规花招（如赌博式放短球）。',
      '一发进球率提高到85%以上！稍微降低球速，打更深更稳的落点，杜绝二发被抢攻的隐患。',
      '把每一分当成0-0来打，不思考盘分，只专注当下这个回合第一拍的落点。'
    ],
    drills: [
      '抢分特训营：从 30-30 开展对抗打到局点，连续打10局',
      '破发点抗压攻防模拟赛'
    ],
    tags: ['关键分', '破发点', '大心脏']
  }
];

/**
 * Generates WeChat friendly formatted text for copying to clipboard
 */
export function formatBaodianForWeChat(rule: BaodianRule): string {
  return `🎾【欢乐网球俱乐部 · Joy Tennis 黄金宝典】
📜《${rule.title}》(${rule.titleEn})
-----------------------------------------
💡 战术口诀：
"${rule.formula}"

🎯 核心精髓：
${rule.summary}

⚡ 实战心法：
${rule.details.map((d, i) => `${i + 1}. ${d}`).join('\n')}

🏋️‍♂️ 特训拉练推荐：
${rule.drills.map((d, i) => `· ${d}`).join('\n')}
-----------------------------------------
🌟 欢乐网球俱乐部 (Joy Tennis Club) · 唯爱AI公益基金会
🌐 在线AI战术教练：https://tennis.weiai.ai`;
}
